<template>
  <button
    class="focus-style collapse-icon mouse-hover"
    :class="{ 'collapse-icon--expanded': value }"
  >
    <span
      class="fa"
      :class="'fa-chevron-right font-size'"
    />
  </button>
</template>

<script>
export default {
  name: 'RuleCaret',
  props: {
    value: {
      type: Boolean,
      required: true,
    },
  },
}
</script>

<style scoped lang='scss'>
.mouse-hover {
  cursor: pointer
}
.collapse-icon {
  font-size: 1em;
  transition: 0.1s transform ease-out;
  &--expanded {
    transform: rotate(90deg);
  }
}
.focus-style {
  border-style: hidden;
  background: none;
  &:focus {
    border-color: #1b89ff;
    border-width: 1px;
    border-style: solid;
    box-shadow: 0 0 5px rgba(27, 137, 255, .5);
  }
}
.font-size {
  font-size: 1rem !important;
}
</style>
